module.exports = __webpack_public_path__ + "static/img/vip-group-zh.d493a489.png";